/**
 * 富文本编辑器
 */
import store from '@/store'
import { baseURL } from '@/assets/js/config.js'
import { Message } from 'element-ui'
import E from 'wangeditor'
// 简单的富文本编辑框菜单
const SIMPLE_MENUS = [
  'head', // 标题
  'bold', // 粗体
  'fontSize', // 字号
  'fontName', // 字体
  'italic', // 斜体
  'underline', // 下划线
  'strikeThrough', // 删除线
  'foreColor', // 文字颜色
  'list', // 列表
  'table', // 表格
  'code', // 插入代码
  'undo', // 撤销
  'redo' // 重复
]
// 复杂的富文本编辑框菜单
const COMPLEX_MENUS = [
  'head', // 标题
  'bold', // 粗体
  'fontSize', // 字号
  'fontName', // 字体
  'italic', // 斜体
  'underline', // 下划线
  'strikeThrough', // 删除线
  'foreColor', // 文字颜色
  'backColor', // 背景颜色
  'link', // 插入链接
  'list', // 列表
  'justify', // 对齐方式
  'quote', // 引用
  'emoticon', // 表情
  'image', // 插入图片
  'table', // 表格
  'code', // 插入代码
  'undo', // 撤销
  'redo' // 重复
]
export default {
  createEditor (document, config = {}) {
    const editor = new E(document)
    editor.config.placeholder = ''
    editor.config.pasteFilterStyle = false // 关闭粘贴样式的过滤
    // editor.config.uploadImgShowBase64 = true // base64 保存图片
    editor.config.uploadImgMaxSize = 1 * 1024 * 1024 // 默认限制图片大小是 5M
    editor.config.uploadFileName = 'file' // 上传文件
    editor.config.uploadImgServer = baseURL + '/resources/uploadFile'
    editor.config.uploadImgParams = {
      token: store.state.token
    }
    editor.config.uploadImgHooks = {
      // 上传图片之前
      before: function (xhr, editor, files) {
        xhr.setRequestHeader('Authorization', store.state.token)
      },
      customInsert: function (insertImgFn, result, editor) {
        // result 即服务端返回的接口
        // console.log('result', result)
        if (result.code === 200 && result.data && result.data.length > 0) {
          // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
          for (const index in result.data) {
            insertImgFn(baseURL + result.data[index].url)
          }
        } else {
          Message.warn(result.msg)
        }
      }
    }
    if (config.height) {
      editor.config.height = config.height // 默认未300px
    }
    if (config.menus) {
      editor.config.menus = config.menus // 根据自己的需求进行菜单栏调整
    }
    if (config.onchange) {
      editor.config.onchange = config.onchange
    }
    if (config.pasteTextHandle) {
      editor.config.pasteTextHandle = config.pasteTextHandle
    } else {
      // word粘贴去除样式
      editor.config.pasteTextHandle = function (pasteStr) {
        const newStr = pasteStr.replace(/@font-face{[^>]*div.Section0{page:Section0;}/g, '')
        return newStr
      }
    }
    editor.create()
    return editor
  },
  createSimpleEditor (document, config = {}) {
    config.menus = SIMPLE_MENUS
    const editor = this.createEditor(document, config)
    return editor
  },
  createComplexEditor (document, config = {}) {
    config.menus = COMPLEX_MENUS
    const editor = this.createEditor(document, config)
    return editor
  }
}
